import { Controller } from "@hotwired/stimulus"

// Facturar una venta pendiente desde la pantalla de la venta.
// Abre un modal que reutiliza el partial sales/_billing_section (selector de CUIT
// + condición IVA del receptor) y postea a sales#create_invoice.
export default class extends Controller {
  static targets = ["modal", "body", "error", "submit"]
  static values = {
    saleId: Number,
    patientId: Number,
    billingDataUrl: String,
    createInvoiceUrl: String,
    csrfToken: String
  }

  async open() {
    this.hideError()
    this.bodyTarget.innerHTML = `
      <div class="text-center py-3 text-muted">
        <i class="fas fa-spinner fa-spin"></i> Cargando datos de facturación...
      </div>
    `
    $(this.modalTarget).modal("show")

    try {
      const response = await fetch(`${this.billingDataUrlValue}?patient_id=${this.patientIdValue}`, {
        headers: {
          "Accept": "text/html",
          "X-CSRF-Token": this.csrfTokenValue
        }
      })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      this.bodyTarget.innerHTML = await response.text()
    } catch (error) {
      console.error("Error cargando datos de facturación:", error)
      this.bodyTarget.innerHTML = `
        <div class="alert alert-warning mb-0">
          No se pudieron cargar los datos de facturación. Intentá nuevamente.
        </div>
      `
    }
  }

  async submit() {
    const billingCuit = this.bodyTarget.querySelector('[name="invoice[billing_cuit]"]')?.value
    const receptorType = this.bodyTarget.querySelector('[name="invoice[receptor_type]"]')?.value

    if (!receptorType) {
      this.showError("Seleccioná la condición IVA del receptor.")
      return
    }

    this.hideError()
    this.submitTarget.disabled = true
    const originalHtml = this.submitTarget.innerHTML
    this.submitTarget.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Facturando...'

    try {
      const response = await fetch(this.createInvoiceUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": this.csrfTokenValue
        },
        body: JSON.stringify({ invoice: { billing_cuit: billingCuit, receptor_type: receptorType } })
      })
      const data = await response.json()

      if (data.success) {
        $(this.modalTarget).modal("hide")
        window.location.reload()
      } else {
        this.showError(data.error || "No se pudo facturar la venta.")
        this.submitTarget.disabled = false
        this.submitTarget.innerHTML = originalHtml
      }
    } catch (error) {
      console.error("Error facturando venta:", error)
      this.showError("Error inesperado al facturar. Intentá nuevamente.")
      this.submitTarget.disabled = false
      this.submitTarget.innerHTML = originalHtml
    }
  }

  showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.style.display = "block"
  }

  hideError() {
    this.errorTarget.style.display = "none"
    this.errorTarget.textContent = ""
  }
}
